var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfterpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8062 3.02719L13.4425 1.68229L11.0447 0.317014C9.45982 -0.586379 7.4787 0.547955 7.4787 2.36832V2.67398C7.4787 2.84379 7.56751 3.00002 7.7178 3.08153L8.83133 3.71323C9.13874 3.88983 9.5213 3.66568 9.5213 3.31247V2.58568C9.5213 2.22568 9.91069 2.00153 10.2249 2.17814L12.411 3.42794L14.5902 4.67096C14.9045 4.84756 14.9045 5.30265 14.5902 5.47925L12.411 6.72227L10.2249 7.97207C9.91069 8.14868 9.5213 7.92453 9.5213 7.56453V7.20453C9.5213 5.38416 7.54019 4.24303 5.9553 5.15322L3.55746 6.51849L1.19379 7.8634C-0.397931 8.77358 -0.397931 11.0626 1.19379 11.9728L3.55746 13.3177L5.9553 14.683C7.54019 15.5864 9.5213 14.452 9.5213 12.6317V12.326C9.5213 12.1562 9.43249 12 9.2822 11.9185L8.16867 11.2868C7.86126 11.1102 7.4787 11.3343 7.4787 11.6875V12.4143C7.4787 12.7743 7.08931 12.9985 6.77507 12.8219L4.58901 11.5721L2.40979 10.329C2.09554 10.1524 2.09554 9.69735 2.40979 9.52075L4.58901 8.27773L6.77507 7.02793C7.08931 6.85132 7.4787 7.07547 7.4787 7.43547V7.79547C7.4787 9.61584 9.45982 10.757 11.0447 9.84678L13.4425 8.4815L15.8062 7.13661C17.3979 6.21963 17.3979 3.93737 15.8062 3.02719Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterpay);
export default __webpack_public_path__ + "static/media/afterpay.73f5894236d91e550b856bfc1a77298d.svg";
export { ForwardRef as ReactComponent };